export default class StoryCards {
	constructor() {
		document.addEventListener('bless', ({ detail }) => {
			this.container = detail.next.container;
			this.init(this.container);
		});

		this.storiesElm = document.querySelector('[data-c-story-overview-stories]');
		document.addEventListener('bless-search-results', () => {
			this.init(this.storiesElm);
		});
	}

	init(container) {
		const storyCards = container.querySelectorAll('[data-story-card]');
		storyCards.forEach((card) => {
			const link = card.querySelector('a');
			const label = card.querySelector('.t-category');
			if (link) {
				card.addEventListener('click', (e) => {
					if (e.target !== link && e.target !== label) {
						link.click();
					}
				});
			}
		});
	}
}
